module.exports = __webpack_public_path__ + "static/media/react.d8149b18.png";